import { IApplicationState } from '../../types/redux';

export const selectModalState = (state: IApplicationState) => state.modal;
